import { CircleNotch, CheckCircle, DownloadSimple, ArrowCounterClockwise, EnvelopeSimple } from "phosphor-react";
import { FC, useState } from "react";
import { downloadInvoice } from "../../services/invoice.service";
import { InvoiceGeneratorProps } from "../interfaces/invoice-generator-props";

interface InvoiceProps {
  data: InvoiceGeneratorProps;
}

const Invoice: FC<InvoiceProps> = (props) => {
  const invoiceId = props.data.invoiceId as string;
  const [isDownloading, setIsDownloading] = useState(false);

  const resetHandler = () => {
    window.location.reload();
  };

  const downloadHandler = async () => {
    try {
      setIsDownloading(true);
      const response = await downloadInvoice(invoiceId);

      let filename = "factura.zip";
      try {
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          filename = contentDisposition.split(";")[1].split("=")[1].replace(/"/g, '');
        }
      } catch (e) {
        console.warn("No se pudo extraer el nombre del archivo.");
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

      setIsDownloading(false);
    } catch (err) {
      console.log(err);
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex flex-col items-center text-center animate-fade-in-up space-y-6">

      {/* Icono de Éxito */}
      <div className="bg-lime-100 p-5 rounded-full mb-2 shadow-sm">
        <CheckCircle size={64} weight="fill" className="text-[#84cc16]" />
      </div>

      {/* TEXTOS MEJORADOS */}
      <div>
        <h2 className="text-2xl font-bold text-slate-800">¡Factura Generada!</h2>
        <p className="text-slate-500 mt-2 text-sm max-w-xs mx-auto">
          Tu comprobante está listo. Hemos enviado los archivos a tu correo.
        </p>
      </div>

      {/* CONFIRMACIÓN DE ENVÍO */}
      {/* Agregué un diseño más explícito: "Enviado a:" */}
      <div className="bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 w-full max-w-xs mx-auto flex flex-col items-center">
        <span className="text-[10px] uppercase font-bold text-slate-400 tracking-wider mb-1">
          Enviado a
        </span>
        <div className="flex items-center space-x-2 text-slate-700 font-medium">
          <EnvelopeSimple size={18} className="text-lime-600" />
          <span className="text-sm text-center break-all px-2" title={props.data.email}>
            {props.data.email || "Correo no registrado"}
          </span>
        </div>
      </div>

      {/* Botones de Acción */}
      <div className="w-full space-y-3 pt-2">
        <button
          onClick={downloadHandler}
          disabled={isDownloading}
          className={`
                w-full py-3.5 rounded-lg font-bold text-white shadow-lg transition-all transform flex justify-center items-center
                ${isDownloading
              ? "bg-slate-300 cursor-not-allowed shadow-none"
              : "bg-[#84cc16] hover:bg-[#65a30d] active:scale-95 shadow-lime-500/30"
            }
            `}
        >
          {isDownloading ? (
            <>
              <CircleNotch size={20} className="animate-spin mr-2" />
              DESCARGANDO...
            </>
          ) : (
            <>
              <DownloadSimple size={20} weight="bold" className="mr-2" />
              DESCARGAR AQUÍ TAMBIÉN
            </>
          )}
        </button>

        <button
          onClick={resetHandler}
          disabled={isDownloading}
          className="w-full bg-slate-800 hover:bg-slate-900 text-white font-bold py-3.5 rounded-lg shadow-lg flex justify-center items-center transition-all active:scale-95"
        >
          <ArrowCounterClockwise size={20} weight="bold" className="mr-2" />
          FACTURAR OTRO TICKET
        </button>
      </div>

    </div >
  );
};

export default Invoice;